<template>
    <div class="box">
        <div class="box2">
            <div class="remark">
                <div class="titleName">提交督办理由</div>
                <div class="notAccepted">
                    <van-field
                    placeholder="最多不能超过40个字"
                    type="textarea"
                    maxlength="40"
                    v-model="remark"
                        />
                </div>
            </div>
            <div class="btn">
                <div class="submit">
                    <van-button type="primary">提交</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="less" scoped>
.box {
    width: 100%;
    padding: 14px;
    background-color: #f4f3f3;
    box-sizing: border-box;
    height: 100%;
    .box2 {
        width: 100%;
        padding: 14px;
        background-color: #fff;
        font-size: 14px;
        box-sizing: border-box;
        .remark {
            width: 100%;
            margin-top: 14px;
            .titleName {
                color: #aaa;
                text-align: left;
            }
            .notAccepted {
                margin-top: 14px;
                .van-cell {
                    font-size: 12px;
                    background: #efeded;
                    border-radius: 7px;
                }
            }
        }
        .btn {
            margin-top: 30px;
            .van-button {
                width: 100%;
                border-radius: 7px;
                margin-top: 10px;
            }
            .back {
                .van-button {
                    color: #bdb8b8
                }
                .van-button--plain {
                    background-color: #efeded;
                }
            }
        }
    }
}
</style>
